module.exports = __webpack_public_path__ + "img/gb2238-80a-5-6.prt.4c27b9a5.jpg";